var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "faq" }, [
    _c(
      "div",
      { staticClass: "main-wrapper" },
      [
        _c("layout-header"),
        _vm._v(" "),
        _c("layout-sidebar"),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [
          _c("div", { staticClass: "content container-fluid" }, [
            _c("div", { staticClass: "page-header" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12" }, [
                  _c("h3", { staticClass: "page-title" }, [_vm._v("FAQ")]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "breadcrumb" }, [
                    _c(
                      "li",
                      { staticClass: "breadcrumb-item" },
                      [
                        _c("router-link", { attrs: { to: "/index" } }, [
                          _vm._v("Dashboard")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "breadcrumb-item active" }, [
                      _vm._v("FAQ")
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(0)
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "faq-card" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title" }, [
            _c(
              "a",
              {
                staticClass: "collapsed",
                attrs: { "data-toggle": "collapse", href: "#collapseOne" }
              },
              [_vm._v("Apa itu Waajo?")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-collapse collapse",
            attrs: { id: "collapseOne" }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("p", [
                _vm._v(
                  "Waajo adalah whatsapp Serverless API yang berfungsi untuk mengirimkan pesan Instant Messaging otomatis. Jadi kamu bisa integrasikan aplikasimu dengan Waajo untuk mengirimkan pesan lewat Whatsapp."
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title" }, [
            _c(
              "a",
              {
                staticClass: "collapsed",
                attrs: { "data-toggle": "collapse", href: "#collapseTwo" }
              },
              [_vm._v("Untuk berikirim pesan menggunakan nomor siapa?")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-collapse collapse",
            attrs: { id: "collapseTwo" }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("p", [
                _vm._v(
                  "Untuk mengirim pesan lewat API dan juga aplikasi Waajo, kamu bisa gunakan nomor kamu sendiri. Caranya cukup scan barcode di linked device kamu."
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title" }, [
            _c(
              "a",
              {
                staticClass: "collapsed",
                attrs: { "data-toggle": "collapse", href: "#collapseThree" }
              },
              [_vm._v("Apakah ini official partner API Whatsapp?")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-collapse collapse",
            attrs: { id: "collapseThree" }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("p", [
                _vm._v(
                  "Tidak, kami adalah penyedia layanan mandiri yang mampu mengotomatisasi aplikasi WA guna mengirim pesan dari channel/toko kamu. Selain itu kami juga fokus menyediakan layanan API Whatsapp."
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title" }, [
            _c(
              "a",
              {
                staticClass: "collapsed",
                attrs: { "data-toggle": "collapse", href: "#collapseFour" }
              },
              [_vm._v("Apakah saya dapat mengirim broadcast pesan?")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-collapse collapse",
            attrs: { id: "collapseFour" }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("p", [
                _vm._v(
                  "Kami menyediakan fasilitas broadcast pesan, namun sebelum mengirimkan pesan broadcast ini, kami sarankan nomor kamu sudah tersimpan di nomor penerima agar tidak dianggap sebagai spam."
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title" }, [
            _c(
              "a",
              {
                staticClass: "collapsed",
                attrs: { "data-toggle": "collapse", href: "#collapseFive" }
              },
              [_vm._v("Bisakah saya tetap menggunakan Whatsapp Web?")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-collapse collapse",
            attrs: { id: "collapseFive" }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("p", [_vm._v("Tetap bisa, tidak perlu khawatir.")])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title" }, [
            _c(
              "a",
              {
                staticClass: "collapsed",
                attrs: { "data-toggle": "collapse", href: "#collapseSix" }
              },
              [
                _vm._v("\n                  Apa itu\n                  "),
                _c(
                  "i",
                  {
                    staticClass: "badge badge-danger",
                    staticStyle: { "font-size": "10px" }
                  },
                  [_vm._v("Beta")]
                ),
                _vm._v(" version?\n                ")
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-collapse collapse",
            attrs: { id: "collapseSix" }
          },
          [
            _c("div", { staticClass: "card-body" }, [
              _c("p", [
                _vm._v(
                  "\n                  Fitur ini belum stabil, terutama di device IOS. Tetapi kamu tidak perlu khawatir, tim Riset\n                  kami sedang bekerja keras untuk menyempurnakannya.\n                "
                )
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5afe9e36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5afe9e36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/faq.vue
// module id = null
// module chunks = 